export default __webpack_public_path__ + "static/media/IMG_5408.f34c27e2.PNG";